import { useState } from "react";
import { Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/common";
import { FormDialog } from "@/components/kids/kidsUi";

export default function ItemEditDialog({ item, base, aisles, canDelete, onClose, onDone }) {
  const [f, setF] = useState({ name: item.name, qty: item.qty || "", note: item.note || "", aisle: item.aisle || "Other" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (fn) => {
    setBusy(true);
    setError("");
    try { await fn(); onDone(); } catch (e) { setError(e.response ? errMsg(e) : "You're offline. Try again when you're back online."); } finally { setBusy(false); }
  };
  const save = () => {
    if (!f.name.trim() || f.name.trim().length > 80) return setError("Item names are 1–80 characters");
    const body = { name: f.name, qty: f.qty, note: f.note };
    if (f.aisle !== (item.aisle || "Other")) body.aisle = f.aisle;
    return run(() => api.patch(`${base}/items/${item.id}`, body));
  };
  return (
    <FormDialog open onClose={onClose} title={`Edit ${item.name}`} testid="item-edit-dialog">
      <div className="space-y-4">
        <Field label="Name" htmlFor="item-name"><input id="item-name" className="q-input" maxLength={80} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="item-edit-name-input" /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Quantity" htmlFor="item-qty"><input id="item-qty" className="q-input" maxLength={20} placeholder="2 or 1 lb" value={f.qty} onChange={(e) => setF({ ...f, qty: e.target.value })} data-testid="item-edit-qty-input" /></Field>
          <Field label="Aisle" htmlFor="item-aisle">
            <select id="item-aisle" className="q-input" value={f.aisle} onChange={(e) => setF({ ...f, aisle: e.target.value })} data-testid="item-edit-aisle-select">
              {aisles.map((a) => <option key={a} value={a}>{a}</option>)}
            </select>
          </Field>
        </div>
        <Field label="Note" htmlFor="item-note"><input id="item-note" className="q-input" maxLength={140} placeholder="boneless" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} data-testid="item-edit-note-input" /></Field>
        {error && <p className="q-error" data-testid="item-edit-error">{error}</p>}
        <div className="flex flex-wrap items-center justify-between gap-2">
          {canDelete ? <button className="q-btn q-btn-danger" disabled={busy} onClick={() => run(() => api.delete(`${base}/items/${item.id}`))} data-testid="item-delete-btn"><Trash2 className="h-4 w-4" /> Delete</button> : <span />}
          <div className="flex gap-2">
            <button className="q-btn q-btn-ghost" onClick={onClose} data-testid="item-edit-cancel-btn">Cancel</button>
            <button className="q-btn q-btn-primary" disabled={busy} onClick={save} data-testid="item-edit-save-btn">Save</button>
          </div>
        </div>
      </div>
    </FormDialog>
  );
}
